import { history, useModel } from '@umijs/max';
import React from 'react';
import {
  getAppearanceMainLogoUrl,
  resolveAppearanceBrandIdentity,
  resolveAppearanceSystemName,
} from '@/utils/theme';
import defaultSettings from '../../../config/defaultSettings';
import useStyles from './index.style';

const HeaderTitle: React.FC = () => {
  const { styles } = useStyles();
  const { initialState } = useModel('@@initialState');
  const fallbackTitle =
    typeof defaultSettings.title === 'string' ? defaultSettings.title : '';
  const appearance = initialState?.appearance;
  const brandIdentity = resolveAppearanceBrandIdentity(appearance);
  const systemName = resolveAppearanceSystemName(appearance, fallbackTitle);
  const logoSrc = getAppearanceMainLogoUrl(appearance);

  return (
    <a
      className={styles.root}
      onClick={(event) => {
        event.preventDefault();
        history.push('/');
      }}
    >
      <img className={styles.logo} src={logoSrc} alt="logo" />
      <div className={styles.title}>
        <span className={styles.brandIdentity}>{brandIdentity}</span>
        <span className={styles.systemName}>{systemName}</span>
      </div>
    </a>
  );
};

export default HeaderTitle;
